import React, { useState, useEffect } from 'react';
import { Box, Typography, IconButton, Backdrop } from '@mui/material';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import Table from '../../../../components/tables/Table';
import tableStyles from '../../../../components/tables/Table.styles';
import styles from './DataQualityTable.styles';

export default function DataQualityTable({ rows = [] }) {
  const [fullScreen, setFullScreen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    setRefreshKey((k) => k + 1);
  }, [fullScreen]);

  const columns = [
    {
      label: 'Date',
      field: 'ReadingDate',
      type: 'date',
      sortable: true,
      render: (_row, v) => {
        if (!v) return '—';
        const dt = new Date(v);
        return isNaN(dt) ? '—' : dt.toLocaleDateString('en-GB');
      },
    },
    { label: 'Missing (Infill)', field: 'Missing_Type7', type: 'number', sortable: true, align: 'right' },
    { label: 'Actual', field: 'Actual', type: 'number', sortable: true, align: 'right' },
    { label: 'Missing (Provided)', field: 'Missing_Type9', type: 'number', sortable: true, align: 'right' },
    { label: 'Uncertain', field: 'Uncertain', type: 'number', sortable: true, align: 'right' },
    { label: 'Pending', field: 'PendingMissing', type: 'number', sortable: true, align: 'right' },
    { label: '% Missing (Infill)', field: 'Percent_Missing_Type7', type: 'number', sortable: true, align: 'right', render: (_r, v) => `${v}%` },
    { label: '% Actual', field: 'Percent_Actual', type: 'number', sortable: true, align: 'right', render: (_r, v) => `${v}%` },
    { label: '% Missing (Provided)', field: 'Percent_Missing_Type9', type: 'number', sortable: true, align: 'right', render: (_r, v) => `${v}%` },
    { label: '% Uncertain', field: 'Percent_Uncertain', type: 'number', sortable: true, align: 'right', render: (_r, v) => `${v}%` },
    { label: '% Pending', field: 'Percent_PendingMissing', type: 'number', sortable: true, align: 'right', render: (_r, v) => `${v}%` },
  ];

  return (
    <>
      {fullScreen && (
        <Backdrop open sx={{ zIndex: 1298, backdropFilter: 'blur(4px)', pointerEvents: 'none' }} />
      )}

      <Box sx={{ ...styles.thirdCard, ...(fullScreen && styles.fullScreenCard) }}>
        <Box sx={styles.headerRow}>
          <Typography variant="subtitle2" sx={styles.headerTitle}>Daily Details</Typography>
          <IconButton
            onClick={() => setFullScreen((prev) => !prev)}
            size="medium"
            sx={styles.fullScreenToggleButton}
            aria-label={fullScreen ? 'Exit full screen' : 'Enter full screen'}
          >
            {fullScreen ? <CloseFullscreenIcon fontSize="small" /> : <OpenInFullIcon fontSize="small" />}
          </IconButton>
        </Box>

        <Box sx={{ ...tableStyles.tableWrapper, flexGrow: 1, minHeight: 0 }}>
          <Table
            key={refreshKey}
            rows={rows}
            columns={columns}
            stickyHeader
            zebra
            hover
            bordered

            defaultSort={{ field: 'ReadingDate', direction: 'desc' }}
          />
        </Box>
      </Box>
    </>
  );
}